export default __webpack_public_path__ + "static/media/edge_scr.a64d920d.png";